<template>
  <div class="profile-manager-section">
    <!-- <button class="profile-manager-section__manage-btn">
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.16667 15.5V10.5H8.83333V12.1667H15.5V13.8333H8.83333V15.5H7.16667ZM0.5 13.8333V12.1667H5.5V13.8333H0.5ZM3.83333 10.5V8.83333H0.5V7.16667H3.83333V5.5H5.5V10.5H3.83333ZM7.16667 8.83333V7.16667H15.5V8.83333H7.16667ZM10.5 5.5V0.5H12.1667V2.16667H15.5V3.83333H12.1667V5.5H10.5ZM0.5 3.83333V2.16667H8.83333V3.83333H0.5Z"
          fill="#0033DD"
        />
      </svg>
      <p>Manage Sections</p>
    </button> -->
    <a-tabs :activeKey="activeKey" class="profile-manager-section__tabs" @tabClick="selectTab">
      <a-tab-pane v-if="isOrg === 'basic' || isOrg === 'organization'" key="experience">
        <template #tab>
          <div class="tab-name">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_998_4095"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="20"
                height="20"
              >
                <rect width="20" height="20" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_998_4095)">
                <path
                  d="M14.1673 7.5H15.834V5.83333H14.1673V7.5ZM14.1673 10.8333H15.834V9.16667H14.1673V10.8333ZM14.1673 14.1667H15.834V12.5H14.1673V14.1667ZM14.1673 17.5V15.8333H17.5007V4.16667H10.0007V5.33333L8.33398 4.125V2.5H19.1673V17.5H14.1673ZM0.833984 17.5V9.16667L6.66732 5L12.5007 9.16667V17.5H7.50065V13.3333H5.83398V17.5H0.833984ZM2.50065 15.8333H4.16732V11.6667H9.16732V15.8333H10.834V10L6.66732 7.04167L2.50065 10V15.8333Z"
                  fill="white"
                />
              </g>
            </svg>
            <p>
              About
            </p>
          </div>
        </template>
        <WorkExperience v-if="isOrg === 'basic'" />
        <Education v-if="isOrg === 'basic'" />
        <div :class="{'organization-public-section':isOrg === 'organization'}">
          <Publications v-if="isOrg === 'basic' || isOrg === 'organization'" />
        </div>
        <OrganizationLocations v-if="isOrg === 'organization'" />
        <TheLanguages v-if="isOrg === 'basic'" />
      </a-tab-pane>
      <a-tab-pane key="photo" v-if="isOrg === 'basic' || isOrg === 'organization'">
          <template #tab>
            <div class="tab-name">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none">
                  <path d="M6 17.9745C6.1287 19.2829 6.41956 20.1636 7.07691 20.8209C8.25596 22 10.1536 22 13.9489 22C17.7442 22 19.6419 22 20.8209 20.8209C22 19.6419 22 17.7442 22 13.9489C22 10.1536 22 8.25596 20.8209 7.07691C20.1636 6.41956 19.2829 6.1287 17.9745 6" stroke="currentColor" stroke-width="1.5" />
                  <path d="M2 10C2 6.22876 2 4.34315 3.17157 3.17157C4.34315 2 6.22876 2 10 2C13.7712 2 15.6569 2 16.8284 3.17157C18 4.34315 18 6.22876 18 10C18 13.7712 18 15.6569 16.8284 16.8284C15.6569 18 13.7712 18 10 18C6.22876 18 4.34315 18 3.17157 16.8284C2 15.6569 2 13.7712 2 10Z" stroke="currentColor" stroke-width="1.5" />
                  <path d="M2 11.1185C2.61902 11.0398 3.24484 11.001 3.87171 11.0023C6.52365 10.9533 9.11064 11.6763 11.1711 13.0424C13.082 14.3094 14.4247 16.053 15 18" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                  <path d="M12.9998 7H13.0088" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <p>
                Photos
              </p>
            </div>
          </template>
          <PhotoResume />
        </a-tab-pane>
       <a-tab-pane key="event" v-if="isOrg === 'basic' || isOrg === 'organization'">
        <template #tab>
          <div class="tab-name">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
            <g>
              <path d="M4,0v2H3C1.9,2,1,2.9,1,4v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2h-1V0h-2v2H6V0H4z M3,7h14v11H3V7z"/>
              <path d="M13.9,16.3l-2.4-1.5L9,16.3l0.6-2.7l-2.1-1.8l2.8-0.2L11.4,9l1.1,2.6l2.8,0.3l-2.1,1.8L13.9,16.3z"/>
            </g>
            </svg>
            <p>
              Events
            </p>
          </div>
        </template>
        <Events />
      </a-tab-pane>
      <a-tab-pane v-if="isOrg === 'basic'" key="network">
        <template #tab>
          <div class="tab-name">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_998_4113"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="20"
                height="20"
              >
                <rect width="20" height="20" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_998_4113)">
                <path
                  d="M0.833984 16.6668V14.3335C0.833984 13.8613 0.955512 13.4272 1.19857 13.0314C1.44162 12.6356 1.76454 12.3335 2.16732 12.1252C3.02843 11.6946 3.90343 11.3717 4.79232 11.1564C5.68121 10.9411 6.58398 10.8335 7.50065 10.8335C8.41732 10.8335 9.3201 10.9411 10.209 11.1564C11.0979 11.3717 11.9729 11.6946 12.834 12.1252C13.2368 12.3335 13.5597 12.6356 13.8027 13.0314C14.0458 13.4272 14.1673 13.8613 14.1673 14.3335V16.6668H0.833984ZM15.834 16.6668V14.1668C15.834 13.5557 15.6638 12.9689 15.3236 12.4064C14.9833 11.8439 14.5007 11.3613 13.8757 10.9585C14.584 11.0418 15.2507 11.1842 15.8757 11.3856C16.5007 11.587 17.084 11.8335 17.6257 12.1252C18.1257 12.4029 18.5076 12.712 18.7715 13.0522C19.0354 13.3925 19.1673 13.7641 19.1673 14.1668V16.6668H15.834ZM7.50065 10.0002C6.58398 10.0002 5.79926 9.67377 5.14648 9.021C4.49371 8.36822 4.16732 7.5835 4.16732 6.66683C4.16732 5.75016 4.49371 4.96544 5.14648 4.31266C5.79926 3.65989 6.58398 3.3335 7.50065 3.3335C8.41732 3.3335 9.20204 3.65989 9.85482 4.31266C10.5076 4.96544 10.834 5.75016 10.834 6.66683C10.834 7.5835 10.5076 8.36822 9.85482 9.021C9.20204 9.67377 8.41732 10.0002 7.50065 10.0002ZM15.834 6.66683C15.834 7.5835 15.5076 8.36822 14.8548 9.021C14.202 9.67377 13.4173 10.0002 12.5007 10.0002C12.3479 10.0002 12.1534 9.9828 11.9173 9.94808C11.6812 9.91336 11.4868 9.87516 11.334 9.8335C11.709 9.38905 11.9972 8.896 12.1986 8.35433C12.4 7.81266 12.5007 7.25016 12.5007 6.66683C12.5007 6.0835 12.4 5.521 12.1986 4.97933C11.9972 4.43766 11.709 3.94461 11.334 3.50016C11.5284 3.43072 11.7229 3.38558 11.9173 3.36475C12.1118 3.34391 12.3062 3.3335 12.5007 3.3335C13.4173 3.3335 14.202 3.65989 14.8548 4.31266C15.5076 4.96544 15.834 5.75016 15.834 6.66683ZM2.50065 15.0002H12.5007V14.3335C12.5007 14.1807 12.4625 14.0418 12.3861 13.9168C12.3097 13.7918 12.209 13.6946 12.084 13.6252C11.334 13.2502 10.577 12.9689 9.81315 12.7814C9.04926 12.5939 8.27843 12.5002 7.50065 12.5002C6.72287 12.5002 5.95204 12.5939 5.18815 12.7814C4.42426 12.9689 3.66732 13.2502 2.91732 13.6252C2.79232 13.6946 2.69162 13.7918 2.61523 13.9168C2.53885 14.0418 2.50065 14.1807 2.50065 14.3335V15.0002ZM7.50065 8.3335C7.95898 8.3335 8.35135 8.1703 8.67773 7.84391C9.00412 7.51752 9.16732 7.12516 9.16732 6.66683C9.16732 6.2085 9.00412 5.81613 8.67773 5.48975C8.35135 5.16336 7.95898 5.00016 7.50065 5.00016C7.04232 5.00016 6.64996 5.16336 6.32357 5.48975C5.99718 5.81613 5.83398 6.2085 5.83398 6.66683C5.83398 7.12516 5.99718 7.51752 6.32357 7.84391C6.64996 8.1703 7.04232 8.3335 7.50065 8.3335Z"
                  fill="#434343"
                />
              </g>
            </svg>
            <p>Network</p>
          </div>
        </template>
        <ConnectionsSection />
      </a-tab-pane>
      <a-tab-pane key="archive" v-if="isOrg === 'basic' || isOrg === 'organization'">
        <template #tab>
          <div class="tab-name">
            <svg viewBox="-0.5 -0.5 16 16" fill="none" class="svg-icon library-svg-icon" xmlns="http://www.w3.org/2000/svg" id="Library--Streamline-Solar-Ar" height="16" width="16">
              <path d="M12.22625 4.375c0.142875 -0.8154812499999999 -0.484625 -1.5625 -1.3125624999999999 -1.5625H4.086325C3.25841875 2.8125 2.6309125 3.5595187499999996 2.77380625 4.375" stroke="#000000" stroke-width="1"></path>
              <path d="M10.9375625 2.8125c0.0176875 -0.16192499999999999 0.026562500000000003 -0.24290625 0.02675 -0.30978125 0.0013750000000000001 -0.63976875 -0.4805625 -1.17731875 -1.116625 -1.24558125C9.7811875 1.25 9.6996875 1.25 9.5368125 1.25H5.46319375c-0.1629 0 -0.24435625 0 -0.31085 0.0071375 -0.63611875 0.0682625 -1.1180125 0.6058125000000001 -1.11661875 1.245575 0.00014375 0.06688125 0.0090125 0.14784999999999998 0.02674375 0.3097875" stroke="#000000" stroke-width="1"></path>
              <path d="M9.375 11.25H5.625" stroke="#000000" stroke-linecap="round" stroke-width="1"></path>
              <path d="M1.4896937499999998 8.620625c-0.27876875 -1.9772500000000002 -0.41814999999999997 -2.9658437500000003 0.17425625 -3.60573125C2.25635625 4.375 3.3109875 4.375 5.42024375 4.375h4.15950625c2.10925 0 3.163875 0 3.7563125000000004 0.63989375 0.592375 0.6398874999999999 0.453 1.62848125 0.17425 3.60573125l-0.26437499999999997 1.875c-0.218625 1.5505625 -0.32787499999999997 2.3258125 -0.888625 2.7901249999999997C11.7965625 13.75 10.9695 13.75 9.315375 13.75H5.6846c-1.65409375 0 -2.48114375 0 -3.0418875 -0.46425 -0.56074375 -0.4643125 -0.6700499999999999 -1.2395625000000001 -0.8886624999999999 -2.7901249999999997l-0.26435625 -1.875Z" stroke="#000000" stroke-width="1"></path>
            </svg>
            <p>Library</p>
          </div>
        </template>
        <div>
          <archive-management></archive-management>
        </div>
      </a-tab-pane>
    </a-tabs>
    <AccessModal
    :visible="visibleAccessModal"
    :type='modalType'
    @closeAccessModal="closeLoginModal"
    @showForgotPasswordModal="showForgotModalPass"
    @showOTPVerificationModal="()=>{this.OtpVerificationModalVisible = true}"
    ></AccessModal>
    <ForgotPasswordModal 
      :visible="forgotModalVisible"
      @cancel="forgotModalVisible=false"
      :footer="null"
    />
    <OtpVerificationModal
    :visible="OtpVerificationModalVisible"
    @close="OtpVerificationModalVisible=false" 
  />
  </div>
</template>

<script>
import TheLanguages from "./TheLanguages.vue";
import Events from "./Events.vue";
import PhotoResume from "./PhotoResume.vue";
import WorkExperience from "./WorkExperience.vue";
import ConnectionsSection from "./ConnectionSection.vue";
import ArchiveManagement from "../ProfilePageComponents/Archive/ArchiveManagement.vue";
import {mapGetters, mapActions} from 'vuex'
import Education from "./Education.vue";
import Publications from "./PublicationsSection.vue";
import AccessModal from "../Auth/AccessModal.vue";
import ForgotPasswordModal from "../Auth/ForgotPasswordModal.vue";
import OtpVerificationModal from "../Auth/OtpVerificationModal.vue";
import OrganizationLocations from "./OrganizationLocationModule/OrganizationLocations.vue";
// import AccessModal from "../Auth/AccessModal.vue";

export default {
  components: {
    WorkExperience,
    ConnectionsSection,
    TheLanguages,
    PhotoResume,
    Events,
    ArchiveManagement,
    Education,
    Publications,
    AccessModal,
    ForgotPasswordModal,
    OtpVerificationModal,
    OrganizationLocations
  },
  data() {
    return {
      activeKey:'',
      isSharedProfileView: false,
      visibleAccessModal: false,
      modalType: "",
      forgotModalVisible: false,
      OtpVerificationModalVisible: false
    }
  },
  watch: {
    activeKey:{
      async handler(tabName){
        if(tabName) {
          this.setActiveTabKey(tabName)
          if (tabName === 'network') {
            this.getAllGroups();
            this.getAllConnection();
            this.getFollowes('basic')
            this.getFollowes('organization')
            this.fetchRecommendedConnections()
            this.fetchRecommendedOrganization()
            this.fetchPendingFriendRequests('pending')
            this.fetchPendingFriendRequests('incoming')
          } else if (tabName === 'archive') {
              this.emptyFolderTreeAndContent()
              this.getFolderTree('public_folders')
            // this.fetchArchiveFoldersList({ visibility: "public", user_id: this.$route.params.id });
          }
        }
      },
      immediate:true
    },
    currentActiveTab:{
      handler(activeTab){
        if(activeTab && this.activeKey !== activeTab){
          this.activeKey = activeTab
        }else if (!activeTab){
          this.activeKey = 'experience' 
        }
      },
      immediate:true
    },
    selectedUserProfile:{
      handler(profile){
        if (profile.username !== this.authUserInformation.profile?.username){
          if (this.activeKey === 'network') {
          this.getAllGroups();
          this.getAllConnection();
          this.getFollowes('basic')
          this.getFollowes('organization')
          
        } else if (this.activeKey === 'archive') {
          this.emptyFolderTreeAndContent()
          this.setSelectedFolder({})
          this.getFolderTree('public_folders')
          // this.fetchArchiveFoldersList({ visibility: "public"});
        }
        }
      },immediate:true
    },
    '$route':{
      handler(to, from){
        this.isSharedProfileView  = to.name === 'share-user-profile' ? true : false
      }, immediate: true
    },
    isSharedProfileView(val){
      if (!val) {
        this.visibleAccessModal = false
      }
      
    }
  },
  computed: {
    ...mapGetters({
      getUserAccountType: "profile/getUserAccountType",
      loggedInUserId: "auth/getUserId",
      currentActiveTab: 'profile/currentActiveTab',
      selectedUserProfile: 'profile/getSelectedUserProfile',
      authUserInformation: 'profile/userInformation',
      fetchOrganizationLocation: 'profile/fetchOrganizationLocation',
      pendingFriendRequests: 'profile/pendingFriendRequests'
    }),
    isOrg() {
      return this.getUserAccountType;
    },
  },
  created(){
    this.visibleAccessModal= false
  },
  beforeUnmount(){
    this.setSelectedUser({...this.authUserInformation.profile, id:this.authUserInformation.id})
    this.setActiveTabKey('experience')
  },
  methods: {
    ...mapActions({
      fetchArchiveFoldersList: "archive/fetchArchiveFoldersList",
      setActiveTabKey: 'profile/setActiveTabKey',
      setSelectedUser: 'profile/setSelectedUser',
      toggleAccessModal: 'profile/toggleAccessModal',
      getFolderTree: 'folders/getFolderTree',
      emptyFolderTreeAndContent: 'folders/emptyFolderTreeAndContent',
      setSelectedFolder: 'archive/setSelectedFolder',
      fetchRecommendedConnections:'feed/fetchRecommendedConnections',
      fetchRecommendedOrganization:'feed/fetchRecommendedOrganization',
      fetchPendingFriendRequests: 'profile/fetchPendingFriendRequests'
    }),
     async getAllGroups() {
      try {
        const payload = {
          user_id: this.$route.params.id,
        };
        await this.$store.dispatch("profile/loadGroups", payload);
      } catch (err) {
        console.log(err);
      }
    },
    async getAllConnection() {
      try {
        const payload = {
          user_id:  this.$route.params.id,
        };
        await this.$store.dispatch("profile/getFriendsList", payload);
      } catch (err) {
        console.log(err);
      }
    },
    async getShareArticles() {
      try {
        this.skeletonLoading = true;
       await this.getShareArticle()
      } catch (error) {
        console.log(error);
      } finally {
        this.skeletonLoading = false;
      }
    },
    selectTab(event){
      if (this.isSharedProfileView){
        this.visibleAccessModal = true
        this.modalType = 'login'
      }else{
       this.activeKey = event
      }
    },
    closeLoginModal(){
      this.visibleAccessModal = false
      this.modalType = ''
    },
    showForgotModalPass() {
      this.forgotModalVisible = true
      this.closeLoginModal();
    },
    async getFollowes(account_type, relation='contributors') {
      try {
        await this.$store.dispatch("feed/fetchContributorsAndOrganizations", {relation, account_type, user_id:this.authUserInformation?.id});
      } catch (error) {
        console.log(error);
      }
    },
  }
};
</script>

<style lang="scss">
.profile-manager-section {
  position: relative;
  &__manage-btn {
    position: absolute;
    right: 2.5rem;
    top: 2.3rem;
    display: flex;
    align-items: center;
    z-index: 1;
    border-radius: 100px !important;
    padding: 0.7rem 1.2rem;
    height: 3rem;
    border: none;
    outline: none;
    background-color: #eaeaea;
    cursor: pointer;
    @include respond(tab-port) {
      top: 2.6rem;
    }
    p {
      font-size: 1.2rem;
      line-height: 1.4rem;
      margin-bottom: 0;
      color: $color-black;
      font-family: $font-primary-medium;
      margin-left: 0.7rem;
      white-space: nowrap;
    }
    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
  &__tabs {
    .ant-tabs-bar {
      border-bottom: 1px solid $color-dark-grey-5;
      margin: 0;
      margin-bottom: 3rem;
      .ant-tabs-nav-container {
        padding: 2.1rem 2.6rem 0;
        @include respond(tab-port) {
          padding: 2.5rem 2.6rem 0;
        }
        .ant-tabs-tab-prev,
        .ant-tabs-tab-next {
          display: none !important;
        }
        .ant-tabs-nav-wrap {
          .ant-tabs-nav-scroll {
            overflow-x: auto;
            @include respond(phone-x-small) {
              &::-webkit-scrollbar {
                display: none !important;
              }
            }
            &::-webkit-scrollbar {
              height: 0.7rem;
            }

            &::-webkit-scrollbar-track {
              background-color: transparent;
              border-radius: 0.8rem;
              height: 0.7rem;
            }

            &::-webkit-scrollbar-thumb {
              background-color: $color-primary;
              border-radius: 0.8rem;
            }
            .ant-tabs-nav {
              width: 100%;
              transform: none !important;
              .ant-tabs-tab {
                background-color: $color-light-grey-3;
                padding: 1rem 1.6rem;
                border-radius: 100px;
                margin-right: 1.6rem;
                border-top-right-radius: 1rem !important;
                border-top-left-radius: 1rem !important;
                border-bottom-left-radius: 0 !important;
                border-bottom-right-radius: 0 !important;
                display: flex;
                align-items: center;
                margin-bottom: -0.1rem;
                @include respond(tab-port) {
                  margin-bottom: -0.2rem;
                }
                .tab-name {
                  display: flex;
                  align-items: center;
                  p {
                    font-size: 1.6rem;
                    line-height: 1.8rem;
                    font-family: $font-primary-medium;
                    color: $color-dark-grey-6;
                    margin-bottom: 0;
                    margin-top: 0.2rem;
                  }
                  svg {
                    margin-right: 1rem;
                    width: 2rem;
                    height: auto;
                  }
                  svg {
                    color: $color-primary;
                  }
                  svg g path {
                    fill: $color-primary;
                  }
                  .library-svg-icon {
                    width: 2.2rem;
                  }
                  .library-svg-icon path {
                    stroke: $color-primary;
                    fill: none !important;
                  }
                }
                &:last-child {
                  margin-right: 0;
                }
                @include respond(tab-port) {
                  padding: 1rem 1.8rem;
                  .tab-name {
                    p {
                      font-size: 1.8rem;
                      line-height: 2rem;
                    }
                  }
                }
              }
              .ant-tabs-tab-active {
                color: $color-white;
                background-color: $color-primary;
                font-family: $font-primary-medium;
                text-shadow: none;
                .tab-name {
                  p {
                    color: $color-white;
                  }
                  svg {
                    color: $color-white;
                  }
                  svg g path {
                    fill: $color-white;
                  }
                  .library-svg-icon path {
                    stroke: $color-white;
                  }
                }
              }
              .ant-tabs-ink-bar {
                display: none !important;
              }
            }
            .ant-tabs-nav > div {
              display: flex;
              align-items: flex-end;
              height: 4rem;
            }
          }
        }
      }
    }
    .ant-tabs-top-content {
      .ant-tabs-tabpane {
        overflow-y: auto;
        padding: 0 0;
        display: block;
        height: calc(100vh - 25rem);
        margin-bottom: 3rem;
        overflow-x: hidden;
        @include respond(tab-port) {
          height: calc(100vh - 30rem);
        }
        .organization-public-section {
          .publication-section {
            padding: 0 2.6rem;
            border-top: none;
          }
        }
        &::-webkit-scrollbar {
          height: 0.3rem;
          width: 0.3rem;
        }

        &::-webkit-scrollbar-track {
          background-color: transparent;
          border-radius: 0.8rem;
          height: 0.3rem;
          width: 0.3rem;
        }

        &::-webkit-scrollbar-thumb {
          background-color: $color-primary;
          border-radius: 0.8rem;
        }
      }
    }
  }
}
</style>
